import { Component, Input } from '@angular/core';

@Component({
  selector: 'pt-sign-header',
  template: `
    <div class="mb-4 w-100 text-center">
      <img class="mb-2" width='70px' *ngIf="logo" [src]="logo" alt=""/>
      <h5 class=" w-100 text-primary mb-1" *ngIf="!subtitle && title">{{title}}</h5>
      <h3 class=" w-100 text-primary mb-1" *ngIf="subtitle && title">{{title}}</h3>
      <p class="mb-2 w-100 text-black-50" *ngIf="subtitle">{{subtitle}}</p>
    </div>
  `
})
export class SignHeaderComponent {
  @Input() logo: string;
  @Input() title: string;
  @Input() subtitle: string;
}
